import { JsonPatchOperation } from "_shared/_api/attorney-hub-api-service";
import EntityAgreement from "legal-entities/agreements/entity-agreement";

export default class UpdateEntityAgreementAPIRequest {
  public get payload(): JsonPatchOperation[] {
    return [...this._payload];
  }

  constructor(oldAgreement: EntityAgreement, newAgreement: EntityAgreement) {
    if (newAgreement.entityName.value !== oldAgreement.entityName.value) {
      this._payload.push({
        op: "replace",
        path: "/EntityName",
        value: newAgreement.entityName.value,
      });
    }

    if (
      (!newAgreement.entityLocation && oldAgreement.entityLocation) ||
      !newAgreement.entityLocation?.isEqualTo(oldAgreement.entityLocation)
    ) {
      this._payload.push({
        op: "replace",
        path: "/EntityLocation",
        value: newAgreement.entityLocation?.toJSON() ?? null,
      });
    }
  }
  private readonly _payload: JsonPatchOperation[] = [];
}

/**
 * Whether the agreement endpoint has anything to apply.
 *
 * The endpoint rejects a patch document that carries no operations, so an officer who accepts the
 * name and location the invitation pre-filled must not be sent through it at all. This is the same
 * diff the request itself takes, so the two cannot disagree about which fields the endpoint accepts.
 */
export function hasEntityAgreementChanges(oldAgreement: EntityAgreement, newAgreement: EntityAgreement): boolean {
  return new UpdateEntityAgreementAPIRequest(oldAgreement, newAgreement).payload.length > 0;
}
